import React from "react";

import LaunchIcon from "@material-ui/icons/Launch";
import { AppList } from "components/list/AppList";
import { Datagrid, Link, TextField } from "react-admin";

import { DateTimeField } from "../../../components/fields/DateFormatField";
import { SelectEnumField } from "../../../components/fields/SelectEnumField";
import { ClientNotificationDeliveryStatus } from "../../../entities/ClientNotificationDeliveryStatus";
import { NotificationSubscriptionEventType } from "../../../entities/NotificationSubscriptionEventType";
import { ReplayButton } from "../Buttons/ReplayButton";
import { Filters } from "../Filter/Filters";


const SubscriptionIdField = ({ record }) => {
	if (record.subscription_id == null) {
		return null;
	}
	return (
		<span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
			{record.subscription_id}
			<Link
				to={`/client-notification-subscriptions/${record.subscription_id}/show`}
				onClick={(e) => e.stopPropagation()}
				target="_blank"
				rel="noopener noreferrer"
			>
				<LaunchIcon fontSize="small" />
			</Link>
		</span>
	);
};


const getStatusColorClass = (status) => {
	switch (status) {
		case ClientNotificationDeliveryStatus.pending:
			return "#FFFFFF";
		case ClientNotificationDeliveryStatus.sending:
			return "#00AFF3";
		case ClientNotificationDeliveryStatus.delivered:
			return "#b7ff7d";
		case ClientNotificationDeliveryStatus.failed:
			return "#ffd28c";
		case ClientNotificationDeliveryStatus.rejected:
			return "#ff8c8c";
		case ClientNotificationDeliveryStatus.dead:
			return "#c0c0c0";
		default:
			return undefined;
	}
};

const rowStyle = (record) => ({
	backgroundColor: getStatusColorClass(record.status),
});

const defaultSort = {
	field: "created_at_utc",
	order: "DESC",
};

const ClientNotificationDeliveriesList = (props) => (
	<AppList
		{...props}
		exporter={false}
		bulkActionButtons={false}
		sort={defaultSort}
		filters={<Filters />}
	>
		<Datagrid rowStyle={rowStyle} rowClick="show">
			<TextField source="id" />
			<SubscriptionIdField source="subscription_id" />
			<SelectEnumField
				source="event_type"
				enumName="notification_subscription"
				enumObj={NotificationSubscriptionEventType}
				sortable={false}
			/>
			<SelectEnumField
				source="status"
				enumName="client_notification_delivery_status"
				enumObj={ClientNotificationDeliveryStatus}
				sortable={false}
			/>
			<TextField source="attempts" />
			<TextField source="response_code" sortable={false} />
			<DateTimeField source="created_at_utc" withLocalTimeZone />
			<DateTimeField source="last_attempt_at_utc" withLocalTimeZone />
			<DateTimeField source="next_retry_at_utc" withLocalTimeZone sortable={false} />
			<ReplayButton />
		</Datagrid>
	</AppList>
);

export default ClientNotificationDeliveriesList;
